import { render } from "./UserAttendance.vue?vue&type=template&id=90ed2846&scoped=true"
import script from "./UserAttendance.vue?vue&type=script&lang=js"
export * from "./UserAttendance.vue?vue&type=script&lang=js"

import "./UserAttendance.vue?vue&type=style&index=0&id=90ed2846&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90ed2846"]])

export default __exports__